import { ArrowDropDown, BarChartOutlined, PanoramaFishEyeOutlined, ShowChart } from '@mui/icons-material';
import { Button } from '@mui/material';
import {
  Widget,
  WidgetContent,
  WidgetHeader,
  WidgetIcon,
  MonsterChart,
  FixedRatio,
  useScrollIntoView,
} from '@procureai/ui-mui';

import { ButtonSelect } from '~/components/ButtonSelect/ButtonSelect';
import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';
import { PlaceholderWidget } from '~/components/PlaceholderWidget/PlaceholderWidget';

import { useSpendAnalysis } from './SpendAnalysisWidget.hooks';

export const SpendAnalysisWidget = () => {
  const [widgetRef, active] = useScrollIntoView({ hash: 'spend-analysis' });
  const { title, subTitle, showAll, sources, left, setLeft, right, setRight, data, dataConfig, yAxis, isLoading } =
    useSpendAnalysis();

  const isDataEmpty = data.length === 0;

  return (
    <Widget hover="js" ref={widgetRef} active={active} data-intercom-target="SpendAnalysisWidget">
      <WidgetHeader
        icon={<WidgetIcon icon={<PanoramaFishEyeOutlined fontSize="small" />} />}
        title={title}
        subTitle={subTitle}
        actionsLeft={
          <>
            <ButtonSelect
              startIcon={<BarChartOutlined />}
              endIcon={<ArrowDropDown fontSize="small" />}
              items={sources}
              selected={left}
              onItemClick={setLeft}
              disabled={isDataEmpty}
            />
            <ButtonSelect
              startIcon={<ShowChart />}
              endIcon={<ArrowDropDown fontSize="small" />}
              items={sources}
              selected={right}
              onItemClick={setRight}
              disabled={isDataEmpty}
            />
          </>
        }
        actionsRight={
          <Button variant="text" disabled>
            {showAll}
          </Button>
        }
      />
      <WidgetContent>
        {!isDataEmpty ? (
          <FixedRatio ratio={0.25}>
            <MonsterChart tooltip legend dataKey="key" data={data} dataConfig={dataConfig} yAxis={yAxis} />
          </FixedRatio>
        ) : isLoading ? (
          <CircularProgressCentered sx={{ position: 'relative' }} />
        ) : (
          <PlaceholderWidget withImage />
        )}
      </WidgetContent>
    </Widget>
  );
};
